import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { m } from "@vega-core/paraglide/messages";

export function ReportSectionMessage({
  dataTestId,
  message,
  onRetry,
}: {
  dataTestId: string;
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div
      className="border border-border/primary rounded-lg card-paddings-default text-center space-y-3"
      data-testid={dataTestId}
    >
      <p className="body-base-regular text-text/secondary">{message}</p>
      {onRetry ? (
        <ThemedButton
          dataTestId={`${dataTestId}-retry`}
          onClick={onRetry}
          size="small"
          variant="primary"
        >
          {m.common_retry()}
        </ThemedButton>
      ) : null}
    </div>
  );
}
